var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calc_rating"},[_c('div',{staticClass:"rating",on:{"click":_vm.openDialog}},[_c('v-rating',{staticClass:"rating_star",attrs:{"value":_vm.values,"color":"yellow darken-3","background-color":"grey darken-1","empty-icon":"$ratingFull","half-increments":"","hover":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }